<template>
  <div class="container">
    <section id="editContent" class="columnContainer controls">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.roomcontrol}}</h1>
        <div class="listSummary">
          <div class="checkbox">
            <input type="checkbox" id="all_control" v-model="chkAll">
            <label for="all_control">{{locale.all}}</label>
          </div>
          <span v-if="chkControl.length > 0" class="chkCnt">{{`${locale.select} ${chkControl.length} / ${list.length}`}}</span>
          <button type="button" class="btn sizeXs btnRed btnReset" @click="delControl" :disabled="chkControl.length === 0">{{locale.delete}}</button>
          <p class="cnt">
            <!-- {{locale.all}} <span class="colorPrimary f_medium">{{channel.length}}</span> / {{list.length}} -->
          </p>
        </div>
        <ControlList
          :locale="locale"
          :list="list"
          :isChkAll="chkAll"
          @checkedItem="checkedItem" />
      </div>
      <!-- <div class="innerSide"><div class="sideBox">
        <ControlFilter
          v-if="controls"
          :locale="locale"
          :filters="filters" />
      </div></div> -->
    </section>
  </div>
</template>

<script>
import ControlList from '@/components/Control/List.vue'

export default {
  name: 'Control',
  props: [
    'locale'
  ],
  components: {
    ControlList
  },
  computed: {
    filters () {
      const properties = this.controls ? this.controls.map(x => getPropertyKey(x.property)) : []
      const filter = [...new Set(properties.flat())]
      function getPropertyKey (obj) {
        return Object.keys(obj).filter(x => !(x.includes('count') || x.includes('Mask') || x.includes('thing') || x.includes('tv') || x.includes('subtype')))
      }
      return filter
    },
    list () {
      function setProperty (obj) {
        const filtered = Object.keys(obj).filter(x => !(x.includes('count') || x.includes('Mask') || x.includes('thing') || x.includes('tv') || x.includes('subtype')))
        const properties = filtered.reduce((o, k) => ({ ...o, [k]: obj[k] }), {})
        return properties
      }
      return this.controls ? this.controls.map(x => {
        return {
          spacetypeid: x.spacetypeid,
          subtype: x.subtype,
          property: setProperty(x.property)
        }
      }) : []
    }
  },
  watch: {
    chkAll (isChkAll) {
      this.chkControl = isChkAll ? this.controls.map(x => x.spacetypeid) : []
    }
  },
  created () {
    this.$store.commit('onLoading', true)
    this.init()
    this.$store.commit('onLoading', false)
  },
  mounted () {
  },
  data () {
    return {
      controls: null,
      chkAll: false,
      chkControl: []
    }
  },
  methods: {
    init () {
      function subtypeSort (arr) {
        return arr.filter(x => x).map(x => Number(x)).sort().map(x => x.toString())
      }
      function getSubtype (arr) {
        let result = []
        arr.forEach(function (spacetype) {
          if (spacetype.property.subtype && spacetype.property.subtype.length && spacetype.property.subtype.filter(x => x !== '0').length > 0) {
            const subtype = subtypeSort(spacetype.property.subtype)
            subtype.forEach(function (x) {
              result.push({
                ...spacetype,
                subtype: x
              })
            })
          } else {
            result.push({
              ...spacetype,
              subtype: '0'
            })
          }
        })
        return result
      }
      this.$store.dispatch('control/getControl').then((res) => {
        this.controls = res && Array.isArray(res) ? getSubtype(res) : []
      })
      this.chkAll = false
      this.chkControl = []
    },
    checkedItem (data) {
      const isChecked = data.isChecked
      if (isChecked) {
        this.chkControl = [...new Set(this.chkControl.concat(`${data.spaceid}|${data.subtype}`))]
      } else {
        this.chkControl = this.controls.filter(x => `${x.spacetypeid}|${x.subtype}` !== `${data.spaceid}|${data.subtype}`).map(x => `${x.spacetypeid}|${x.subtype}`)
      }
    },
    delControl () {
      /**
       * 서브타입이 0이 아니면 서브타입 정보만 update
       * 서브타입이 0이면 모든 property 삭제
       */
      function getSpacetypes (arr) {
        let result = []
        arr.forEach(function (x) {
          const exist = result.find(r => r.spacetype === x.spacetype)
          exist
            ? exist.subtype.push(x.subtype)
            : result.push({ spacetype: x.spacetype, subtype: [x.subtype] })
        })
        return result
      }
      if (window.confirm(this.locale.confirm_delete_roomcontrol)) {
        const chks = this.chkControl.map(x => {
          const spaceData = x.split('|')
          return {
            spacetype: spaceData[0],
            subtype: spaceData[1]
          }
        })
        const spacetypes = getSpacetypes(chks)
        this.$store.commit('onLoading', true)
        this.$store.dispatch('control/delControls', spacetypes).then((res) => {
          this.$store.dispatch('control/getControl').then((res) => {
            this.init()
          })
          this.$store.commit('onLoading', false)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer .innerSide {
  width: 300px;
}
#editContent.columnContainer .sideBox {
  margin-left: 0;
  padding-left: 0;
}
.listSummary {
  display: flex;
  align-items: center;
  margin-bottom: 0.5em;
}
.cnt {
  margin-left: auto;
}
.noData {
  padding: 120px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 64px;
    margin-bottom: 30px;
    background: url('~@/assets/img/ico_search.svg') 50% 50% / contain no-repeat;
    opacity: 0.2;
  }
}
.chkCnt {
  margin-right: 0.5em;
}
.btnReset[disabled] {
  opacity: 0.5;
}
</style>
